export const GET_SEGMENTS = "GET_SEGMENTS";
export const SET_SEGMENTS_FETCHING_STATUS = "SET_SEGMENTS_FETCHING_STATUS";

export const FAILED = "FAILED";
export const FETCHING = "FETCHING";
export const SUCCESS = "SUCCESS";
